export const RENT_GUARANTEE_DISPLAY_NAME = 'Rental Protection';

export const VOUCHER_TO_RENT_COVERAGE = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
};

export const VERIFY_INCOME_ELIGIBLE_CTA_TEXT = 'Eligible';
export const VERIFY_INCOME_INELIGIBLE_CTA_TEXT = 'Ineligible';

export const VERIFY_INCOME_FULL_RENT_CTA_TEXT = 'Covers full rent';
export const VERIFY_INCOME_PARTIAL_RENT_CTA_TEXT = 'Covers partial rent';

export const RP_COMPLETE_TRACKING_LABEL = 'RP_Complete';
export const RP_INCOMPLETE_TRACKING_LABEL = 'RP_Incomplete';

export const RP_APPLICATION_OVERVIEW_UPSELL_VIEW_ACTION = 'View::RentalProtection::ApplicationOverviewUpsell';
export const RP_APPLICATION_OVERVIEW_UPSELL_CLICK_ACTION =
  'Click::FindOutMore::RentalProtection::ApplicationOverviewUpsell';

export const APPLICATION_ELIGIBILTY_STATUSES = {
  ELIGIBLE: 'eligible',
  INELIGIBLE: 'ineligible',
  NOT_VERIFIED: 'notVerified',
};

export const RP_NOT_IDENTIFIED_TRACKING_LABEL = 'RP_NotIDverified';

export const RP_CUSTOMER_SUPPORT_EMAIL = 'rentalprotection@zillowinsuranceservices.com';

export const RP_APPLICATION_UPSELL_ENTRYPOINT = 'ApplicationsOptInUpsell';

export const RP_OPT_IN_UPSELL_QUERY_PARAMS = `productIntroType=sohIllustrative&entryPoint=${RP_APPLICATION_UPSELL_ENTRYPOINT}`;
